import useDiscard from "../../useDiscard";
import useWeakMap from "../../utils/useWeakMap";

const store = useWeakMap();

const useLayerSwapper = (fromLayer, toLayer) => {
    const item = store.get(fromLayer)
    if (!item) return;
    store.set(toLayer, item);
    store.delete(fromLayer);
    item.onSwapped(toLayer);
}

export const initLayerSwapper = (fromLayer) => {
    if (!store.has(fromLayer)) {
        store.set(fromLayer, {
            onSwapped: () => { }
        });
    }

    useDiscard(fromLayer, (props) => store.delete(props));

    return {
        onSwapped: (fn) => {
            store.get(fromLayer).onSwapped = fn
        }
    }

}

export default useLayerSwapper;